import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./Components/Navbar";
import HomePage from "./Pages/HomePage";
import LoginPage from "./Pages/LoginPage";
import RegisterPage from "./Pages/RegisterPage";
import ResetPassword from "./Pages/ResetPassword";
import ResetPasswordConfirm from "./Pages/ResetPasswordConfirm";
import Doctors from "./Pages/Doctors";
import PrivateRoute from "./Utils/PrivateRoute";
import PersistLogin from "./Components/PersistLogin";
import DoctorDetail from "./Pages/DoctorDetail";
import { AuthProvider } from "./Context/AuthContext";
import Unauthorized from "./Pages/Unauthorized";
import PublicRoute from "./Utils/PublicRoute";
import NotAllowed from "./Pages/NotAllowed";
import PageNotFound from "./Pages/PageNotFound";
import AccountActivate from "./Pages/AccountActivate";
import AddDoctor from "./Pages/AddDoctor";
import EditDoctor from './Pages/EditDoctor'
import BookAppointment from "./Pages/BookAppointment";
import EditAppointment from "./Pages/EditAppointment";
import AppointmentTable from "./Pages/AppointmentTable";
import Prescription from "./Pages/Prescription";
import Medicine from "./Pages/Medicine";
import PrescriptionView from "./Pages/PrescriptionView";
import PostBlog from "./Pages/PostBlog";
import BlogList from "./Pages/BlogList";
import ReadBlog from "./Pages/ReadBlog";
import EditBlog from "./Pages/EditBlog";
import MyBlogs from "./Pages/MyBlogs";
import ReviewForm from "./Pages/ReviewForm";
import ReviewTable from "./Pages/ReviewTable";
import EditPatientProfile from "./Pages/EditPatientProfile";
import PatientProfile from "./Pages/PatientProfile";
import UserTable from "./Pages/UserTable";
import DoctorTable from "./Pages/DoctorTable";
import Settings from "./Pages/Settings";
import AboutUs from "./Pages/AboutUs";
import ContactUs from "./Pages/ContactUs";
import Footer from "./Components/Footer";
import BookingFailed from "./Pages/BookingFailed";
import Notification from "./Pages/Notification";

function App() {
  return (
    <div className="App" style={{minHeight: 100 + 'vh'}}>
      <BrowserRouter>
        <AuthProvider>
          <Navbar />
          <Routes>
            <Route element={<PersistLogin />}>
              {/* public routes */}
              <Route path="/" element={<HomePage />} />
              <Route path="/*" element={<PageNotFound />} />
              <Route path="/blogs" element={<BlogList />} />
              <Route path="/blogs/read/:id" element={<ReadBlog />} />
              <Route path="/about" element={<AboutUs />} />
              <Route path="/contact" element={<ContactUs />} />
              <Route path="/doctor" element={<Doctors />} />

              {/* link accessible only when not logged in */}
              <Route element={<PublicRoute />}>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/account/activate/:uid/:token" element={<AccountActivate />} />
                <Route path="/reset/password" element={<ResetPassword />} />
                <Route path="/reset/password/confirm" element={<ResetPasswordConfirm />} />
              </Route>

              {/* protected routes */}
              {/* links allowed for admin */}
              <Route element={<PrivateRoute allowedRole={[0]} />}>
                <Route path="/add/doctor" element={<AddDoctor />} />
                <Route path="/medicine" element={<Medicine />} />
                <Route path="/user/list" element={<UserTable />} />
                <Route path="/doctor/list" element={<DoctorTable />} />
              </Route>

              {/* links allowed for doctor */}
              <Route element={<PrivateRoute allowedRole={[1]} />}>
                <Route path="add/prescription/:id" element={<Prescription />} />
                <Route path="/post/blog" element={<PostBlog />} />
                <Route path="/edit/blog/:id" element={<EditBlog />} />
                <Route path="/my/blogs" element={<MyBlogs />} />
              </Route>

              {/* links allowed for patient */}
              <Route element={<PrivateRoute allowedRole={[2]} />}>
                <Route path="/doctor/:id" element={<DoctorDetail />} />
                <Route path="/book/doctor/:id" element={<BookAppointment />} />
                <Route path="/give/review" element={<ReviewForm />} />
                <Route path="/edit/profile" element={<EditPatientProfile />} />
                <Route path="/profile" element={<PatientProfile />} />
                <Route path="/failed" element={<BookingFailed />} />
              </Route>

              {/* links allowed for all authenticated users */}
              <Route element={<PrivateRoute allowedRole={[0,1,2]} />}>
                <Route path="/unauthorized" element={<Unauthorized />} />
                <Route path="/notallowed" element={<NotAllowed />} />
                <Route path="/list/appointment" element={<AppointmentTable />} />
                <Route path="/view/prescription/:id" element={<PrescriptionView />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/notification" element={<Notification />} />
              </Route>

              {/* links allowed for admin and doctor */}
              <Route element={<PrivateRoute allowedRole={[0,1]} />}>
                <Route path="/edit/doctor/:id" element={<EditDoctor />} />
              </Route>

              {/* links allowed for admin and patient */}
              <Route element={<PrivateRoute allowedRole={[0,2]} />}>
                <Route path="/list/review" element={<ReviewTable />} />
                <Route path="/edit/appointment/:id" element={<EditAppointment />} />
              </Route>
            </Route>
          </Routes>
          <Footer />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
